import { 
  collection, addDoc, updateDoc, doc, getDocs, getDoc, query, where, orderBy, Timestamp 
} from 'firebase/firestore';
import { db } from '../firebase/config';

const COLLECTION_NAME = 'casos';

export const ESTADOS_CASO = {
  NUEVO: 'nuevo',
  EN_VERIFICACION: 'en_verificacion',
  EN_PROCESO: 'en_proceso',
  COMPLETADO: 'completado',
  CANCELADO: 'cancelado'
};

// Crear un nuevo caso
export const crearCaso = async (casoData) => {
  try {
    const dataWithTimestamp = {
      ...casoData,
      fechaCreacion: Timestamp.now(),
      fechaActualizacion: Timestamp.now(),
      estado: ESTADOS_CASO.NUEVO,
      activo: true
    };
    const docRef = await addDoc(collection(db, COLLECTION_NAME), dataWithTimestamp);
    return { id: docRef.id, ...dataWithTimestamp };
  } catch (error) {
    console.error("Error al crear caso:", error);
    throw error;
  }
};

// Obtener caso por ID
export const obtenerCasoPorId = async (id) => {
  try {
    const docRef = doc(db, COLLECTION_NAME, id);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      return {
        id: docSnap.id,
        ...docSnap.data(),
        fechaCreacion: docSnap.data().fechaCreacion?.toDate()
      };
    }
    return null;
  } catch (error) {
    console.error("Error al obtener caso:", error);
    throw error;
  }
};

// Obtener casos por cliente
export const obtenerCasosPorCliente = async (clienteId) => {
  try {
    const q = query(
      collection(db, COLLECTION_NAME),
      where("clienteId", "==", clienteId),
      where("activo", "==", true),
      orderBy("fechaCreacion", "desc")
    );
    const querySnapshot = await getDocs(q);
    return querySnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data(),
      fechaCreacion: doc.data().fechaCreacion?.toDate()
    }));
  } catch (error) {
    console.error("Error al obtener casos:", error);
    throw error;
  }
};

// Obtener todos los casos
export const obtenerTodosLosCasos = async () => {
  try {
    const q = query(
      collection(db, COLLECTION_NAME),
      where("activo", "==", true),
      orderBy("fechaCreacion", "desc")
    );
    const querySnapshot = await getDocs(q);
    return querySnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data(),
      fechaCreacion: doc.data().fechaCreacion?.toDate()
    }));
  } catch (error) {
    console.error("Error al obtener casos:", error);
    throw error;
  }
};

// Actualizar caso
export const actualizarCaso = async (id, datosActualizados) => {
  try {
    const docRef = doc(db, COLLECTION_NAME, id);
    await updateDoc(docRef, {
      ...datosActualizados,
      fechaActualizacion: Timestamp.now()
    });
    return true;
  } catch (error) {
    console.error("Error al actualizar caso:", error);
    throw error;
  }
};

// Actualizar estado del caso
export const actualizarEstadoCaso = async (id, nuevoEstado) => {
  try {
    const docRef = doc(db, COLLECTION_NAME, id);
    await updateDoc(docRef, {
      estado: nuevoEstado,
      fechaActualizacion: Timestamp.now()
    });
    return true;
  } catch (error) {
    console.error("Error al actualizar estado:", error);
    throw error;
  }
};